import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { ICandidate, getJobById, IJob } from 'wisestep-api';
import {
  ChatBoxHeader,
  Item,
  WsDrawer,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import ProwAndProUpload from './ProwAndProUpload';
import SAPFieldGlassUpload from './SAPFieldGlassUpload';

interface IUploadToVMS {
  candidate: ICandidate;
  onClose: () => void;
}

const UploadToVMS = ({ candidate, onClose }: IUploadToVMS) => {
  const [job, setJob] = useState<IJob | null>(null);
  const [allowUpload, setAllowUpload] = useState(true);
  const [vmsSource, setVMSSource] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      if (candidate?.jobId != null && job == null) {
        const data = await getJobById(candidate.jobId);
        data.data.jobSource !== 'SAPfieldglass' && data.data.jobSource !== 'prowandpro'
          ? setAllowUpload(false)
          : setVMSSource(data.data.jobSource);
        setJob(data.data);
      }
    })();
  }, [candidate.jobId, job]);

  return (
    <WsDrawer
      style={{ zIndex: '1300' }}
      size="medium"
      hideHeader={true}
      open={true}
      onClose={onClose}
      hideOverflow={true}
    >
      <ChatBoxHeader>
        <Grid container p={1}>
          <Grid item xs={3}>
            <Box mt={0}>
              <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.PRIMARY} bold={true}>
                Submit to VMS
              </WsTypography>
            </Box>
          </Grid>
          <Grid item xs={9}>
            <Box sx={{ float: 'right', mr: 2 }}>
              <Stack direction="row" spacing={3}>
                <WsTypography variant={WsTypoVariants.BODY1} bold={true}>
                  {`${job?.title} ( ${job?.jobCode} )`}
                </WsTypography>
                <CloseIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </ChatBoxHeader>
      {allowUpload ? (
        <>
          {vmsSource === 'SAPfieldglass' && <SAPFieldGlassUpload candidate={candidate} />}
          {vmsSource === 'prowandpro' && <ProwAndProUpload candidateDetail={candidate} />}
        </>
      ) : (
        <Item>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} bold color={WsTypoColors.RED}>
            {`Incorrect job found`}
          </WsTypography>
          <Box mt={2}>
            <WsTypography>
              Please submit the candidate to the job which is from VMS (SAPfieldglass or prowandpro)
            </WsTypography>
          </Box>
        </Item>
      )}
    </WsDrawer>
  );
};

export default UploadToVMS;
